<template>
  <div class="dialog-edit-op-permission-warapper">
    <el-dialog title="修改权限" width="70%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">

        <el-form-item label="权限名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="权限代号" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>

        <el-form-item label="权限资源列表" prop="resources">
          <el-select
            v-model="form.resources"
            multiple filterable clearable collapse-tags>
            <el-option
              v-for="res in opResourceList"
              :key="res.resource_id"
              :label="res.name"
              :value="res.resource_id">
              <span>{{ res.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogEditOpPermission',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    editingPermission: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        name: [
          { required: true, message: '请输入权限的名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入权限的代号', trigger: 'blur' }
        ],
        resources: [
          { required: true, message: '请选择权限的资源', trigger: 'change' }
        ]
      },
      form: {
        name: '',
        code: '',
        resources: []
      }
    }
  },
  computed: {
    ...mapState('acl', [
      'opResourceList'
    ])
  },
  methods: {
    ...mapActions('acl', [
      'updateOpPermission',
      'getOpResources'
    ]),

    async getSelectData () {
      try {
        await this.getOpResources({
          page: 1,
          pageSize: 9999
        })
      } catch (err) {
        console.log(err)
        this.$meesage({
          type: 'error',
          message: '获取资源列表失败'
        })
      }
    },

    onDialogOpen () {
      this.getSelectData()

      this.form.name = this.editingPermission.name
      this.form.code = this.editingPermission.code
      this.form.resources = []
      this.editingPermission.resources.forEach(res => {
        this.form.resources.push(res.resource_id)
      })
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },

    async cleanAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      clean.resources.splice(0, clean.resources.length)
      const resourceDetail = []
      this.form.resources.forEach(res => {
        const findRes = this.opResourceList.find(item => {
          return item.resource_id === res
        })
        if (findRes) {
          clean.resources.push(findRes)
          resourceDetail.push(findRes.name)
        }
      })
      clean.resourceDetail = resourceDetail.join(',')

      try {
        await this.updateOpPermission({
          permissionId: this.editingPermission.perm_id,
          name: clean.name,
          code: clean.code,
          resources: clean.resources,
          resourceDetail: clean.resourceDetail
        })

        this.$refs['form'].resetFields()
        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        console.log(err)
      }
    },
    onFormSubmit () {
      if (this.$refs['form'].validate()) {
        this.cleanAndSubmit()
      }
    },
    onFormCancel () {
      this.$refs['form'].resetFields()
      this.form.resources = []
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/components/DialogEditOpPermission.vue